//水印
let Watermark = {
  init: function (employeeId) {
    var browserKernel = this.getBrowser("n"); // 所获得的就是浏览器所用内核。
    var browserVersion = this.getBrowser("v");// 所获得的就是浏览器的版本号。
    //var browser = getBrowser();// 所获得的就是浏览器内核加版本号。
    if (browserKernel == "ie" && (browserVersion == "8.0" || browserVersion == "7.0" || browserVersion == "6.0")) {
      return;
    }
    // $(".watermask_div").hide();
    let waterMasks = document.getElementsByClassName("watermask_div");
    for (let i = 0; i < waterMasks.length; i++) {
      document.body.removeChild(waterMasks[i]);
    }
    this.create({watermark_txt: this.encodeNum(employeeId), watermark_objName: 'body'})
  },
  getBrowser: function (n) {
    var ua = navigator.userAgent.toLowerCase(),
      s,
      name = '',
      ver = 0;
    //探测浏览器
    (s = ua.match(/msie ([\d.]+)/)) ? _set("ie", _toFixedVersion(s[1])) :
      (s = ua.match(/firefox\/([\d.]+)/)) ? _set("firefox", _toFixedVersion(s[1])) :
        (s = ua.match(/chrome\/([\d.]+)/)) ? _set("chrome", _toFixedVersion(s[1])) :
          (s = ua.match(/opera.([\d.]+)/)) ? _set("opera", _toFixedVersion(s[1])) :
            (s = ua.match(/version\/([\d.]+).*safari/)) ? _set("safari", _toFixedVersion(s[1])) : 0;

    function _toFixedVersion(ver, floatLength) {
      ver = ('' + ver).replace(/_/g, '.');
      floatLength = floatLength || 1;
      ver = String(ver).split('.');
      ver = ver[0] + '.' + (ver[1] || '0');
      ver = Number(ver).toFixed(floatLength);
      return ver;
    }

    function _set(bname, bver) {
      name = bname;
      ver = bver;
    }

    return (n == 'n' ? name : (n == 'v' ? ver : name + ver));
  },
  encodeNum: function (num) {
    var encodeNum = "";
    var numArr = num.split("");
    for (var i = 0; i < numArr.length; i++) {
      var numChar = numArr[i];
      var encodeNumChar = "";
      switch (numChar) {
        case "1":
          encodeNumChar = "i";
          break;
        case "2":
          encodeNumChar = "R";
          break;
        case "3":
          encodeNumChar = "o";
          break;
        case "4":
          encodeNumChar = "Q";
          break;
        case "5":
          encodeNumChar = "T";
          break;
        case "6":
          encodeNumChar = "v";
          break;
        case "7":
          encodeNumChar = "W";
          break;
        case "8":
          encodeNumChar = "X";
          break;
        case "9":
          encodeNumChar = "Y";
          break;
        case "0":
          encodeNumChar = "z";
          break;
      }
      encodeNum += encodeNumChar;
    }
    return encodeNum;
  },
  create: function (settings) {
    //默认设置
    var defaultSettings = {
      watermark_objName: "body",
      watermark_txt: "text",
      watermark_x: 0,//水印起始位置x轴坐标
      watermark_y: 20,//水印起始位置Y轴坐标
      watermark_rows: 20,//水印行数
      watermark_cols: 20,//水印列数
      watermark_x_space: 0,//水印x轴间隔
      watermark_y_space: 5,//水印y轴间隔
      watermark_color: '#000',//水印字体颜色
      watermark_alpha: 0.05,//水印透明度
      watermark_fontsize: '30px',//水印字体大小
      watermark_font: 'Wingdings',//水印字体
      watermark_width: 270,//水印宽度
      watermark_height: 80,//水印长度
      watermark_angle: 30//水印倾斜度数
    };
    //采用配置项替换默认值，作用类似jquery.extend
    if (arguments.length === 1 && typeof arguments[0] === "object") {
      var src = arguments[0] || {};
      for (let key in src) {
        if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key])
          continue;
        else if (src[key])
          defaultSettings[key] = src[key];
      }
    }
    //var obj=document.getElementById(defaultSettings.watermark_objName);
    var obj = document.getElementsByTagName(defaultSettings.watermark_objName)[0];
    var oTemp = document.createDocumentFragment();

    //获取页面最大宽度
    //var page_width =obj.offsetWidth; //Math.max(document.body.scrollWidth,document.body.clientWidth);
    var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
    var cutWidth = page_width * 0.0150;
    var page_width = page_width - cutWidth;
    //获取页面最大长度
    //var page_height = obj.offsetHeight ;//Math.max(document.body.scrollHeight,document.body.clientHeight);
    // var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight);
    var page_height = 1450;
    // console.log("滚动高度：" + document.body.scrollHeight);
    // console.log("客户端高度：" + document.body.clientHeight);
    // console.log("最大高度：" + page_height);
    //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
    if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
      defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
      defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
    }
    //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
      defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
      defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
    }
    var x;
    var y;
    for (var i = 0; i < defaultSettings.watermark_rows; i++) {
      y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
      for (var j = 0; j < defaultSettings.watermark_cols; j++) {
        x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;

        var mask_div = document.createElement('div');
        mask_div.id = 'mask_div' + i + j;
        mask_div.className = 'watermask_div';
        mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
        //设置水印div倾斜显示
        mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.visibility = "";
        mask_div.style.position = "fixed";
        mask_div.style.left = x + 'px';
        mask_div.style.top = y + 'px';
        mask_div.style.overflow = "hidden";
        mask_div.style.zIndex = "999999999";
        //mask_div.style.border="solid #eee 1px";
        mask_div.style.opacity = defaultSettings.watermark_alpha;
        mask_div.style.fontSize = defaultSettings.watermark_fontsize;
        mask_div.style.fontFamily = defaultSettings.watermark_font;
        mask_div.style.color = defaultSettings.watermark_color;
        mask_div.style.textAlign = "center";
        mask_div.style.width = defaultSettings.watermark_width + 'px';
        mask_div.style.height = defaultSettings.watermark_height + 'px';
        mask_div.style.display = "block";
        mask_div.style.letterSpacing = 2;
        mask_div.style.pointerEvents = "none";

        oTemp.appendChild(mask_div);
      }
      ;
    }
    ;
    //将水印添加到容器中
    //obj.appendChild(oTemp);
    document.body.appendChild(oTemp);
  }
};
export default Watermark;



// WEBPACK FOOTER //
// ./src/utils/watermark.js